var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCapOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.87667 13.2V16.9467C3.87667 17.92 4.41 18.8267 5.26333 19.2933L11.93 22.9333C12.73 23.3733 13.69 23.3733 14.49 22.9333L21.1567 19.2933C22.01 18.8267 22.5433 17.92 22.5433 16.9467V13.2L14.49 17.6C13.69 18.04 12.73 18.04 11.93 17.6L3.87667 13.2ZM11.93 0.32L0.69 6.45333C-0.23 6.96 -0.23 8.29333 0.69 8.8L11.93 14.9333C12.73 15.3733 13.69 15.3733 14.49 14.9333L25.21 9.08V16.96C25.21 17.6933 25.81 18.2933 26.5433 18.2933C27.2767 18.2933 27.8767 17.6933 27.8767 16.96V8.41333C27.8767 7.92 27.61 7.48 27.1833 7.24L14.49 0.32C13.69 -0.106667 12.73 -0.106667 11.93 0.32V0.32Z",
    fill: "#FF8258"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCapOrange);
export default __webpack_public_path__ + "static/media/icon_cap_orange.f01ee4337fba3653575dc06e8235c6aa.svg";
export { ForwardRef as ReactComponent };